import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import './index.css';
import { installGlobalErrorReporting } from './utils/clientErrorReporter';

// Errori non gestiti fuori dall'albero React → log PM2 (POST /api/client-errors)
installGlobalErrorReporting();

// Ignora errore benigno di ResizeObserver (loop completed with undelivered notifications)
// Questo errore è un warning non critico che si verifica quando ResizeObserver
// rileva cambiamenti più velocemente di quanto possa notificarli in un frame
const resizeObserverLoopErr = /^ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (resizeObserverLoopErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

// Sovrascrive il metodo error della console per filtrare l'errore ResizeObserver
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && resizeObserverLoopErr.test(args[0])) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
